import React from 'react'

import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'

import NavButton from './nav-button'

import '../../global-scss/index.scss'

export default function HomeNav() {
  return (
    <Row className="home-background-light">
      <Col xs={12} className="d-none d-md-flex justify-content-center p-3 flex-wrap">
        <NavButton
          to="/unit-introduction/overview"
          subtitle="Unit"
          title="Introduction"
        />
        <NavButton
          to="/chapter-1/engage/chapter-1-engage-slash-explore-overview"
          subtitle="Chapter 1"
          title="Digestion"
        />
        <NavButton
          to="/chapter-2/bridge/chapter-1-2-bridge-overview"
          subtitle="Chapter 2"
          title="Absorption"
        />
        <NavButton
          to="/chapter-3/bridge/chapter-2-3-bridge-overview"
          subtitle="Chapter 3"
          title="Reactions"
        />
        <NavButton
          to="/chapter-4/bridge/chapter-3-4-bridge-overview"
          subtitle="Chapter 4"
          title="Interactions"
        />
      </Col>
      <Col xs={12} className="d-block d-md-none p-4">
        <NavButton
          to="/unit-introduction/overview"
          subtitle="Unit"
          title="Introduction"
          className="w-100 mt-3"
        />
        <NavButton
          to="/chapter-1/engage/chapter-1-engage-slash-explore-overview"
          subtitle="Chapter 1"
          title="Digestion"
          className="w-100"
        />
        <NavButton
          to="/chapter-2/bridge/chapter-1-2-bridge-overview"
          subtitle="Chapter 2"
          title="Absorption"
          className="w-100"
        />
        <NavButton
          to="/chapter-3/bridge/chapter-2-3-bridge-overview"
          subtitle="Chapter 3"
          title="Reactions"
          className="w-100"
        />
        <NavButton
          to="/chapter-4/bridge/chapter-3-4-bridge-overview"
          subtitle="Chapter 4"
          title="Interactions"
          className="w-100 mb-3"
        />
      </Col>
    </Row>
  )
}
